import PropTypes from "prop-types";
import React from "react";
import Happy from "../../../assets/assets/happy.png";
import PendingIcon from "../../../assets/assets/nip-pending.svg";

const MigrationApproval = (props) => {
  const {scheduleMigrationStatus, migrationApproval } = props;

  return (
    <div className="doc-upload">
      <div className="doc-pending">
      {scheduleMigrationStatus && !migrationApproval &&
          <div className="middle-box">
            <div className="middle-box-image">
              <img src={PendingIcon} alt="pending icon" />
            </div>
            <div className="middle-box-title">
              Migration Approval Pending
          </div>
            <span className="middle-box-subtitle">
              Kindly check back when admin
              approves
          </span>
          </div>
        }

        {scheduleMigrationStatus && migrationApproval &&
          <div className="middle-box">
            <div className="middle-box-image3">
              <img src={Happy} alt="success icon" />
            </div>
            <div className="middle-box-title">
              Hurray!!! Migration successfully done
            </div>
            <span className="middle-box-subtitle">
              You’ve been moved to live environment.
            </span>
          </div>
        }
      </div>
    </div>
  );
};

MigrationApproval.propTypes = {
  migrationApproval: PropTypes.any,
  scheduleMigrationStatus: PropTypes.any
}

export default MigrationApproval;
